export const FIELD = '/field';
export const GET_FIELDS = '/field/';
export const DELETE_FIELD = '/field';
export const ADD_FIELD = '/field/';
export const UPDATE_FIELD = '/field';
export const GET_USER_COLLECTIONS = '/field/collections';

export const FIELD_ITEM = '/field-item';
export const GET_FIELD_ITEMS = '/field-item/';
export const DELETE_FIELD_ITEM = '/field-item';
export const ADD_FIELD_ITEM = '/field-item/';
export const UPDATE_FIELD_ITEM = '/field-item';

export const FIELD_TYPE = '/field-type';
export const GET_FIELD_TYPES = '/field-type/';
export const DELETE_FIELD_TYPE = '/field-type';
export const ADD_FIELD_TYPE = '/field-type/';
export const UPDATE_FIELD_TYPE = '/field-type';

export const SCREEN = '/screen';
export const GET_SCREENS = '/screen/';
export const DELETE_SCREEN = '/screen';
export const ADD_SCREEN = '/screen/';
export const UPDATE_SCREEN = '/screen';

export const SCREEN_FIELD = '/screen-field';
export const GET_SCREEN_FIELDS = '/screen-field/';
export const DELETE_SCREEN_FIELD = '/screen-field';
export const ADD_SCREEN_FIELD = '/screen-field/';
export const UPDATE_SCREEN_FIELD = '/screen-field';

export const PAGE = '/page';
export const GET_PAGE = '/page/';
export const DELETE_PAGE = '/page';
export const ADD_PAGE = '/page/';
export const UPDATE_PAGE = '/page';

export const PAGE_TYPE = '/page_type';
export const GET_PAGE_TYPE = '/page_type/';
export const DELETE_PAGE_TYPE = '/page_type';
export const ADD_PAGE_TYPE = '/page_type/';
export const UPDATE_PAGE_TYPE = '/page_type';

export const GRAPH = '/graph';
export const GET_GRAPH = '/graph/';
export const DELETE_GRAPH = '/graph';
export const ADD_GRAPH = '/graph/';
export const UPDATE_GRAPH = '/graph';

export const REPORTS = '/reports';
export const GET_REPORTS = '/reports/';
export const DELETE_REPORTS = '/reports';
export const ADD_REPORTS = '/reports/';
export const UPDATE_REPORTS = '/reports';

export const REPORT_TEMPLATE = '/report_template';
export const GET_REPORT_TEMPLATE = '/report_template/';
export const DELETE_REPORT_TEMPLATE = '/report_template';
export const ADD_REPORT_TEMPLATE = '/report_template/';
export const UPDATE_REPORT_TEMPLATE = '/report_template';
